import React from 'react';

import './ButtonPrimary.scss';

const ButtonPrimary = props => (
  <button type="button" className={`button button--primary ${props.extraClass ? `${props.extraClass}` : ''}`} onClick={props.onClick}>{props.children}</button>
);

export default ButtonPrimary;
